import { render, staticRenderFns } from "./AppFieldsManager.vue?vue&type=template&id=e84c09e6&scoped=true&"
import script from "./AppFieldsManager.vue?vue&type=script&lang=js&"
export * from "./AppFieldsManager.vue?vue&type=script&lang=js&"
import style0 from "./AppFieldsManager.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AppFieldsManager.vue?vue&type=style&index=1&id=e84c09e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84c09e6",
  null
  
)

export default component.exports